export const toArray = (str: string, separator?: string) => str.split(separator || ",");
